var map = {
	"./baac.svg": "94a5",
	"./bbl.svg": "429b",
	"./bnp.svg": "f6b5",
	"./boa.svg": "7302",
	"./cacib.svg": "a3cd",
	"./cimb.svg": "5da8",
	"./citi.svg": "b3e5",
	"./db.svg": "09d4",
	"./ghb.svg": "fa0c",
	"./gsb.svg": "6766",
	"./hsbc.svg": "497b",
	"./ibank.svg": "13a6",
	"./icbc.svg": "355d",
	"./jpm.svg": "aa50",
	"./kbank.svg": "fa32",
	"./kk.svg": "a47b",
	"./krungsri.svg": "61a5",
	"./ktb.svg": "934e",
	"./lh.svg": "28cd",
	"./lhb.svg": "37e4",
	"./mb.svg": "70f0",
	"./mega.svg": "54c1",
	"./mufg.svg": "2d18",
	"./rbs.svg": "aaf8",
	"./sc.svg": "e50a",
	"./scb.svg": "bd2f",
	"./smbc.svg": "db8f",
	"./tbank.svg": "a171",
	"./tcrb.svg": "3055",
	"./tisco.svg": "9e6c",
	"./tmb.svg": "fc09",
	"./uob.svg": "5619"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dc8";